/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
} from 'reactstrap';
import Input from '../../Input';
import Toggle from '../../Toggle';
import FileUpload from '../../FileUpload';
import ImageDisplay from '../../ImageDisplay';

class EntryPage extends React.PureComponent {
  render() {
    const { values } = this.props;

    return (
      <Row className="px-5 py-3 fade-in">
        <Col className="col-6">
          <FileUpload id="entryPageImage" label="Image:" />
          <ImageDisplay id="entryPageImage" />
          <Toggle label="Dosage Display:" id="dosageDisplay" />
        </Col>
        <Col>
          <Input
            label="Site Title"
            id="guideName"
            value={values.guideName}
          />
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (store) => ({
  validation: store.theme.validation,
  selectedFormularySite: store.sites.selectedFormularySite,
  values: store.sites.values,
});

export default connect(mapStateToProps)(EntryPage);
